/**
 * Coded, user-safe errors. `message` is Thai because it is shown to the buyer;
 * `code` is what the client switches on.
 */
export const ERROR_CODES = [
  'event_not_configured',
  'event_not_open',
  'event_closed',
  'participant_not_found',
  'item_not_found',
  'size_not_found',
  'color_not_found',
  'color_required',
  'shipping_disabled',
  'address_required',
  'empty_order',
  'too_many_lines',
  'invalid_input',
  'order_not_found',
  'price_changed',
  'size_price_mismatch',
  'invalid_transition',
  'rate_limited',
  'forbidden',
  'payment_provider_error',
] as const
export type ErrorCode = (typeof ERROR_CODES)[number]

export class AppError extends Error {
  constructor(
    readonly code: ErrorCode,
    message: string,
    readonly details?: Record<string, unknown>,
  ) {
    super(message)
    this.name = 'AppError'
  }
}

export const appError = (code: ErrorCode, message: string, details?: Record<string, unknown>) =>
  new AppError(code, message, details)
